// extracted by mini-css-extract-plugin
module.exports = {"movies":"stylesCarousel_movies___3UcQ","movie":"stylesCarousel_movie__ipXiQ","notation":"stylesCarousel_notation__3mOnt","back-to-top":"stylesCarousel_back-to-top__1qdGR"};